// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/entity_file.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.EntityFile
 */
export const EntityFile = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EntityFile",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "sha256", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "uploaded_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "download_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEntityFilesRequest
 */
export const ListEntityFilesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntityFilesRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEntityFilesResponse
 */
export const ListEntityFilesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEntityFilesResponse",
  () => [
    { no: 1, name: "files", kind: "message", T: EntityFile, repeated: true },
    { no: 2, name: "total_size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.UploadEntityFileRequest
 */
export const UploadEntityFileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadEntityFileRequest",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UploadEntityFileResponse
 */
export const UploadEntityFileResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadEntityFileResponse",
  () => [
    { no: 1, name: "file", kind: "message", T: EntityFile },
  ],
);

/**
 * @generated from message omnios.v1.DeleteEntityFileRequest
 */
export const DeleteEntityFileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteEntityFileRequest",
  () => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteEntityFileResponse
 */
export const DeleteEntityFileResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteEntityFileResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetEntityFileDownloadUrlRequest
 */
export const GetEntityFileDownloadUrlRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEntityFileDownloadUrlRequest",
  () => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEntityFileDownloadUrlResponse
 */
export const GetEntityFileDownloadUrlResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEntityFileDownloadUrlResponse",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

